import React from 'react';

import { type ModalInnerProps } from '@/hooks/common/useModal';

import UnlinkConfirmModal from './UnlinkConfirmModal';

interface Props extends ModalInnerProps {
  parentName: string;
  parentId: number;
  code: string;
}

const UnlinkOtherParentConfirmModal: React.FC<Props> = ({
  isOpen,
  toggle,
  parentName,
  parentId,
  code,
}) => (
  <UnlinkConfirmModal
    isOpen={isOpen}
    toggle={toggle}
    parentId={parentId}
    code={code}
    targetName={parentName}
    description="この操作は取り消せません。"
    showNotifyEmailNotice={true}
  />
);

export default UnlinkOtherParentConfirmModal;
